import ChatProvider from '../store/schema/ChatProvider';
import setIsSkypePaneShown from '../ucwa/chatManager/setIsSkypePaneShown';
import { setIsChatCalloutShown } from '../actions/bootstrapActions';
import { getStore } from '../store/chatStore';

export default function setIsSkypeShown(isShown: boolean) {
    if (getStore().chatProvider == ChatProvider.UCWA) {
        setIsSkypePaneShown(isShown);
    }
    setIsChatCalloutShown(isShown);
}
